import React from 'react'
import styled from 'styled-components'
import CircleNumber from './CircleNumber';
import NormalText from './NormalText';
import { media } from '../styles/Mixin'
import PropTypes from "prop-types";



export const NormalBorderBox = ({
    text,
    number,
}) => {

    return (
        <Wrapper>
            <CustomText text={text} />
            <CategoryNumber number={number}/>
        </Wrapper>
    )
}

NormalBorderBox.propTypes = {
    text: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
};

export default NormalBorderBox;

const Wrapper = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    border-bottom:${props => props.theme.borderBottom};
    cursor:pointer;
    ${media.deskTop`
        width:60%;
       max-width:1000px;
       padding:5px;
    `}
  ${media.mobile`
    width:70%;
    `}
`

const CustomText = styled(NormalText)`
    padding:10px;
`

const CategoryNumber = styled(CircleNumber)`
    padding:10px;
`

